import { Aurelia, StandardConfiguration } from '@aurelia/runtime-html';

import App from './app';

new Aurelia().register(StandardConfiguration).app({component: App, host: document.body}).start();
